import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { TranslateModule } from '@ngx-translate/core';

import { Mat3ButtonComponent } from '../../base-components/mat3-button/mat3-button.component';

@Component({
    selector: 'app-tour-floating-prompt',
    imports: [
        TranslateModule,
        MatIconModule,
        Mat3ButtonComponent,
    ],
    templateUrl: './tour-floating-prompt.component.html',
    styleUrls: ['./tour-floating-prompt.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourFloatingPromptComponent {
    public isVisible = input.required<boolean>();
    public startTour = output<void>();
    public dismiss = output<void>();

    protected isSkipped = signal<boolean>(false);

    protected onStartTour(): void {
        this.startTour.emit();
    }

    protected onSkip(): void {
        this.isSkipped.set(true);
    }

    protected onDismiss(): void {
        this.dismiss.emit();
    }
}
